module.exports = __webpack_public_path__ + "static/img/dian-active.f81eb654.png";